/**
 * The eastern house with its oriel (lifted from lantern-water's `prefabs/east-house.js`): the house shell of
 * `house-shell.ts`, type 2, 5.5 × 4.4 m, walls 4.6 m, at the local origin (the house's centre, on its
 * terrace: the placement's `h`). With its oriel (`oriel` at front + 0.02, centre 3.32); every mesh may open in the leader's cutaway. Params: `ivy` (true) and `windowBoxes` (true), the
 * prototype's optional decorations.
 */
import * as THREE from 'three';
import { houseShell, oriel } from '../house-shell.ts';
import { flag } from '../kit.ts';
import type { Prefab } from './types.ts';

const model = { width: 5.5, depth: 4.4, height: 4.6, type: 2 } as const;

export const prefab: Prefab = {
  id: 'house_east',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    houseShell(ctx, root, 0, 0, model.width, model.depth, model.height, model.type, { ivy: flag(ctx, 'ivy', true), windowBoxes: flag(ctx, 'windowBoxes', true) });
    oriel(ctx, root, 0, model.depth / 2 + 0.02, 3.32);
    // The leader's cutaway may open the whole house (`world.js` tags the east house's group).
    ctx.cutaway(root);
    return { root, sockets: { chimney: [model.width * 0.3, model.height + 2.65, -0.5], lantern: [model.width * 0.47, 2.15, model.depth / 2 + 0.51] } };
  },
};
